<template>
<p>HomeView</p>
</template>

<script>
export default {
  name: "HomeView",
  components: {},
  setup() {},
};
</script>

<style scoped>

</style>
